const _BATTLECHECK = 5000;
const _STARTBATTLE = 1000;
const _FLIP = 1000;
Vue.component('user-events', {
    template: templates.userEvents, // Keep the same template but simplified
    data() {
        return {
            model: {
                audio: {},
                cards: {},
                abilities: [],
                boneCards: {},
                ascensionCard: {},
                showModal: false,
                isOpen: false,
                eventOpen: false,
                prepareBattle: false,
                tabs: '',
                index: 0,
                eventName: '',
                battle: {
                    selectedTeam: {},
                    team: null,
                    teams: [],
                    abilities: [],
                    settings: {},
                    audio: {},
                    logs: [],
                    events: [],
                    cardNumber: [],
                    cards1: [],
                    cards2: [],
                    index1: 0,
                    index2: 0,
                    userLevel: 0,
                    saving: false,
                    user1: {
                        twitchId: null,
                        twitchDisplayName: null,
                        twitchProfileImage: null,
                    },
                    user2: {
                        twitchId: null,
                        twitchDisplayName: null,
                        twitchProfileImage: null,
                    },
                    result: null,
                    show: {
                        winner: false,
                        cards: false,
                        stolenCard: false,
                        users: false,
                        move: false,
                        logs: false,
                        modal: true
                    }
                },
                selectedEvent: {},
                timer: null,
                slideIndex: 1,
                slides: [],
                hasEvent: false,
                events: [],
                rewards: {
                    otherRewards: [],
                    userCards: [],
                    userPacks: [],
                    rewardChests: [],
                    rewardCardBacks: [],
                    rewardBackgrounds: [],
                    rewardFrames: [],
                    frameDrops: [],
                    backgroundDrops: [],
                    eventCards: [],
                    exoticCards: [],
                    variantCards: [],
                    deltaCards: [],
                    rewardCount: 0,
                },
                packs: {},
            },
            isScrollable: false,
            isScrolledToBottom: false,
            toolbarStyle: {
              left: "0px",
            },
        }
    },
    created() {
      const c = this;
      c.get();
      c.getAbilities();
      c.getCards();
      c.getBones();
      c.getAscension();
      c.getPacks();
      c.connect();
      c.startTimers();
      c.setupSounds();
    },
    mounted() {
      const c = this;
      c.$root.$on('open-events-modal', () => {
          c.model.isOpen = !c.model.isOpen;
      });

      c.$root.$on('open-announcement-modal', () => {
          c.model.isOpen = false;
      });

      $('[data-view="viewer-dashboard"]').on('click', '.reward-modal', function() {
        $('.reward-modal').removeClass('active');

        // c.$root.$emit('updateCards')
        // c.resetRewards();
        // console.log('asdasdasd')
        c.model.rewards = {
            otherRewards: [],
            userCards: [],
            userPacks: [],
            rewardChests: [],
            rewardCardBacks: [],
            rewardBackgrounds: [],
            rewardFrames: [],
            frameDrops: [],
            backgroundDrops: [],
            eventCards: [],
            exoticCards: [],
            variantCards: [],
            deltaCards: [],
            rewardCount: 0,
        }
        c.model.audio.reward.pause()
        c.model.audio.reward.currentTime = 0;
      });

      c.$root.$on('claim_rewards', rewards => {
        let data = {
          twitchId :utils.cookies.get('user_id'),
          rewards : rewards,
          completed : 1,
          isBattle : 1,
          eventId: c.model.selectedEvent.userEvent[0].eventId,
          status: c.model.selectedEvent.userEvent[0].status,
          id: c.model.selectedEvent.userEvent[0].id
        } 
        console.log(data)

        eventsService.saveUserEvent(data)
        .then(function(response){
          c.getRewards(data);
          c.saveProcessedRewards(data.twitchId);
          c.get(c.model.tabs, c.model.index)
        })
        .catch(function(error){
          // c.get();
        })
 
  
      })

      c.$root.$on('event_task_reward_claim', data => {
          data.twitchId = utils.cookies.get('user_id')
          data.isTask = true;
          eventsService.saveUserEvent(data)
          .then(function(response){
            c.getRewards(data);
            c.get(c.model.tabs, c.model.index)
          })
          .catch(function(error){
            // c.get();
          })

      })
      

      c.checkOverflow();
      window.addEventListener('resize', c.checkOverflow);
    },
    computed: {
        formattedDateFrom() {
          const c = this;
          return new Date(c.model.selectedEvent.date_from).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false 
          });
        },
        formattedDateTo() {
          const c = this;
          return new Date(c.model.selectedEvent.date_to).toLocaleDateString('en-US', {
              month: 'long',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: false 
          });
        },
        barksStyle() {
          return {
              backgroundImage: `url(${root}/images/coin-sample.png)`, 
              backgroundSize: 'cover',
              width: '300px', 
              height: '300px'
          };
        },
        currentEventType() {
          const c = this;
          const event = c.model.selectedEvent;
          if (event.isLogin) return 'login';
          if (event.selectedMode === 'battle') return 'battle';
          if (event.tournament) return 'tournament';
          if (event.quest) return 'quest';
          return 'task';
        },
        questModeText() {
          const c = this;
          const selectedMode = c.model.selectedEvent.quest?.selectedMode;
          if (selectedMode === 'to_win') return 'Win using cards on the list only';
          if (selectedMode === 'to_defeat') return 'Defeat the cards listed below';
          return 'Win and Defeat the cards listed below';
        },
        canStartQuest() {
          const c = this;
          return c.model.selectedEvent.userEvent != null && 
                  c.model.selectedEvent.userEvent[0].completed === 0;
        },
        canStartBattle() {
          const c = this;
          return c.model.selectedEvent.userEvent != null &&
                  c.model.selectedEvent.userEvent[0].completed === 0 && c.model.selectedEvent.userEvent[0].active === 1
                  &&  c.model.selectedEvent.userEvent[0].status === 0;
        },
        gridStyle() {
          const c = this;
          const len = c.model.battle.team ? c.model.battle.team.length : 1;
          return { gridTemplateColumns: `repeat(${len}, 1fr)` };
        },
        canClaimReward(){
          const c = this;
          return c.model.selectedEvent.userEvent != null && 
                  c.model.selectedEvent.userEvent[0].status === 1 && c.model.selectedEvent.userEvent[0].active === 0
                  && c.model.selectedEvent.userEvent[0].completed === 0;
        },
        rewardClaimed(){
          const c = this;
          return c.model.selectedEvent.userEvent != null && 
                  c.model.selectedEvent.userEvent[0].status === 1 && c.model.selectedEvent.userEvent[0].completed === 1
                  && c.model.selectedEvent.userEvent[0].active === 0;
        }
    },
    methods: {
        setupSounds(){
          const c = this;
          let reward = `${root}/audio/reward-open.mp3`;
          c.model.audio.reward = new Audio(reward);
          c.model.battle.audio.hit = new Audio(`${root}/audio/hit.mp3`);
          c.model.battle.audio.flip = new Audio(`${root}/audio/card-flip.mp3`);
          c.model.battle.audio.move = new Audio(`${root}/audio/whoosh-02.mp3`);
          c.model.battle.audio.win = new Audio(`${root}/audio/award-01.mp3`);
          c.model.battle.audio.pop = new Audio(`${root}/audio/pop.mp3`);
          c.model.battle.audio.reward = new Audio(`${root}/audio/reward.mp3`);
      
        },
        connect() {
          const c = this;
          const wsUrl = utils.getWsUrl();

          console.log('[userEvents] Connecting to WebSocket:', wsUrl);
          c.ws = new WebSocket(wsUrl);

          c.ws.onmessage = (event) => {
              const messageData = event.data;
              try {
                  const parsedData = JSON.parse(messageData);
                  if(parsedData.message === 'streamer_accept_event' && parsedData.to === utils.cookies.get('user_id')){
                    c.get(c.model.tabs, c.model.index);
                  }
              } catch (error) {
                  console.error('Error parsing message data:', error);
              }
          };

          c.ws.onopen = () => {
              console.log('[userEvents] WebSocket connection established');

              // Send authentication message after connection opens
              const accessToken = utils.cookies.get('access_token');
              const userId = utils.cookies.get('user_id');
              if (accessToken && userId) {
                c.ws.send(JSON.stringify({
                  message: 'auth',
                  token: accessToken,
                  userId: userId
                }));
                console.log('[userEvents] Sent auth message');
              }
          };

          c.ws.onerror = (error) => {
              console.error('[userEvents] WebSocket error:', error);
          };

          c.ws.onclose = (event) => {
              console.log('[userEvents] WebSocket connection closed. Code:', event.code, 'Reason:', event.reason);
          };
        },
        getAbilities() {
          const c = this;
          let data = {};


          abilityService
            .get()
            .then(function (response) {
              for (let d of response.data) {
                data[`${d.id}`] = d;
              }

              c.model.abilities = data;
            })
            .catch(function (error) {
              console.log(error)
              
              c.getAbilities();
            });
        },
        getCards() {
          const c = this;

          cardService.get()
            .then(function (response) {
              c.model.cards = response.data;
            })
            .catch(function (error) {
              //console.log(error);
            });
        },
        getBones() {
          const c = this;

          let data = {};

          boneCardService.get()
            .then(function (response) {
              for (let d of response.data) {
                data[`${d.id}`] = d;
              }
              c.model.boneCards = data;
            })
            .catch(function (error) {
              //console.log(error);
            });
        },
        getAscension() {
          const c = this;

          let data = {};

          boneCardService.getAscension()
            .then(function (response) {
              for (let d of response.data) {
                data[`${d.id}`] = d;
              }
              c.model.ascensionCard = data;
            })
            .catch(function (error) {
              //console.log(error);
            });
        },
        getPacks() {
          const c = this;
          packService.get()
            .then(function (response) {
              let data = {};
              for (let pack of response.data) {
                data[`${pack.id}`] = pack;
              }
              c.model.packs = data;
            })
            .catch(function (error) {
              console.log('Error loading packs:', error);
            });
        },
        get(tab = null, index = null) {
          const c = this;
              console.log('clidked')
          eventsService.getActiveUserEvents().then((response) => {
            
              c.model.events = response.data;
           
              // Process card images
              c.processEventCards(response.data[c.model.index]);
              c.model.selectedEvent = response.data[c.model.index];
              c.model.eventName = response.data[c.model.index].id;

              console.log(response)

              if(tab){
                c.model.tabs = tab
              }
              else{
                c.setInitialTab();
              }
            
              c.model.hasEvent = true;

              console.log(c.model)
          })
          .catch((error) => {
              console.error('Error fetching events:', error);
          });
        },
        processEventCards(event) {
            if (event.cards && event.cards.length > 0) {
                event.cards = event.cards.map(card => ({
                    ...card,
                    image: `${root}/images/cards/${card.baseCardId}.png`
                }));
            }

            if (event.temporaryCards && event.temporaryCards.length > 0) {
                event.temporaryCards = event.temporaryCards.map(card => ({
                    ...card,
                    image: `${root}/images/temp_cards/${card.id}.png`
                }));
            }
        },
        setInitialTab() {
            const c = this;
            console.log('asdasdas');
            const event = c.model.selectedEvent;
            if (event.isLogin) {
                c.model.tabs = 'daily_login';
            } else if (event.selectedMode === 'battle') {
                c.model.tabs = 'battle';
            } else if (event.tournament) {
                c.model.tabs = 'tournament';
            } else if (event.quest) {
                c.model.tabs = 'quest';
            }
            c.model.showModal = false
        },
        startTimers() {
          const c = this;
          setInterval(() => {
              let data = c.model.selectedEvent;
              if (data.cooldown > 0) {
                  data.cooldown -= 1; 
                  c.formatTime(data.cooldown);
              } else {
                  c.isOpen = false;
              }
          }, 1000);
        },
        formatTime(time) {
          const c = this;
          var days = ~~(time / 86400);
          var hrs = ~~((time % 86400) / 3600);
          var mins = ~~((time % 3600) / 60);
          var secs = ~~time % 60;

          var ret = "";
          if (days > 0) {
              ret += days + " days "; 
          }
          if (hrs > 0) {
              ret += hrs + "h:" + (mins < 10 ? "0" : "");
          }
          ret += mins + "m"

          c.model.timer = ret;
        },
        closeDrawer() {
          const c = this; 
          $('.announcement-overlay').removeClass('is-above').removeClass('is-visible');
          setTimeout(() => {
              c.isOpen = false;
              $('.header').removeClass('z-index-zero');
          }, 500);
        },
        toggleDrawer() {
          const c = this;
          c.isOpen = true;
        },
        tabs(tabName) {
          const c = this;
          c.model.tabs = tabName;
        },
        selectedEvent(eventId, event, index) {
          const c = this;
          c.model.index = index
          c.model.eventName = eventId;
          c.processEventCards(event);
          c.model.selectedEvent = event;
          console.log(event)
          c.setInitialTab();
        },
        // Battle-related methods (keeping existing functionality)
        openEventBattle() {
          const c = this;
          c.model.eventOpen = true;
          c.model.hasEvent = false;
          c.model.battle.show.winner = true;
          c.model.prepareBattle = true;
          c.setupSounds();
          c.getTeams();
        },
        getTeams(){
          const c = this;
          const userEvent = c.model.selectedEvent.userEvent;
          c.model.battle.team = (userEvent && userEvent[0]) ? userEvent[0].cards : [];
          c.showStats();
        },
        showStats() {
          $('.info').removeClass('is-visible');
          $('.bottom').removeClass('is-hidden');
        },
        startEventBattle() {
          
          const c = this;
          c.model.battle.show.winner = false;
          c.model.battle.user1Cards = c.model.battle.team;

          if (c.model.selectedEvent.cards) {
              c.model.battle.user2Cards = c.model.selectedEvent.cards;
          } else {
              c.model.battle.user2Cards = c.model.selectedEvent.temporaryCards;
          }

          setTimeout(() => {
            c.processBattle(c.model.battle);
          }, 500);
        },
        getSettings() {
          const c = this;
          
          let data = {};

          settingsService.get()
            .then(function (response) {
              for (let d of response.data) {
                data[`${d.key}`] = d;
              }
              c.model.settings = data;

              
            })
            .catch(function (error) {
              
            });

        },
        backToEvent() {
          const c = this;
       
          c.reset();

          c.get();
          c.getAbilities();
          c.getCards();
          c.getBones();
          c.getAscension();
          c.getPacks();
          c.connect();
          c.startTimers();
          c.setupSounds();
        },
        // Utility methods
        checkOverflow() {
          const c = this;
          const el = c.$refs.col1;
          if (!el) return;
          c.isScrollable = el.scrollHeight > el.clientHeight;
          c.checkScrollPosition();
        },
        checkScrollPosition() {
          const c = this;
          const el = c.$refs.col1;
          if (!el) return;
          c.isScrolledToBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
        },
        onScroll() {
          const c = this;
          c.checkScrollPosition();
        },
        toggleModal() {
          const c = this;
          c.model.showModal = !c.model.showModal;
        },
        processBattle(data) {
          const c = this;
          c.model.battle.id = data.id;

          // c.getStatus();

          let cards1 = playingCards.getCardsStats(data.user1Cards, c.model.abilities);
          let cards2 = playingCards.getCardsStats(data.user2Cards, c.model.abilities);

          c.model.battle.cards1 = cards1;
          c.model.battle.cards2 = cards2;
          // c.model.user1Faction = data.user1Faction;
          // c.model.user2Faction = data.user2Faction;
          
          setTimeout(function() {
            c.startBattle();
          }, _STARTBATTLE);
        },
        startBattle: function() {
          const c = this;

          //c.model.battle.show.battle = true;

          c.showStats();
          

          setTimeout(function() {
            c.model.battle.show.users = true;

            setTimeout(function() {
              c.model.battle.show.move = true;

              setTimeout(function() {
                c.model.battle.show.cards = true;

                setTimeout(function() {
                  c.flip(c.model.battle.cards1[0], 0);
                  c.flip(c.model.battle.cards2[0], 0);
                  c.model.battle.audio.flip.play();

                  //TODO seems like this isn't supposed to be here
                  // c.applyTurnAbiltiy(c.model.battle.cards1[0], c.model.battle.cards2, c.model.battle.cards1);
                  // c.applyTurnAbiltiy(c.model.battle.cards2[0], c.model.battle.cards2, c.model.battle.cards1);

                  setTimeout(function() {
                    c.applyInitialAbilities(c.model.battle.cards1, c.model.battle.cards2, c.model.battle.index1, c.model.battle.index2);
                    c.applyInitialAbilities(c.model.battle.cards2, c.model.battle.cards1, c.model.battle.index2, c.model.battle.index1);
                    c.applyTurnAbiltiy(c.model.battle.cards1[0], c.model.battle.cards1, c.model.battle.cards2, c.model.battle.index1, c.model.battle.index2);
                    c.applyTurnAbiltiy(c.model.battle.cards2[0], c.model.battle.cards2, c.model.battle.cards1, c.model.battle.index2, c.model.battle.index1);
                      c.startRound(Math.random());
                  }, 1500);
                }, 1000);
              }, 1000);
            }, 1500)
          }, 500)
    
        },
        applyInitialAbilities: function(cards1, cards2, index1, index2) {
          const c = this;
          for (let card of cards1) {
            try {
              if (card.abilityKey && typeof abilities.initial[`${card.abilityKey}`] === 'function') {
                abilities.initial[`${card.abilityKey}`](cards1, cards2, index1, index2, c.model.battle.events, c.logEvent.bind(c));
                c.logEvent(`${card.name} used ${card.ability}!`, 'ability', { tier: card.tier });
              }
            } catch(err) {
              c.logError(`${card.ability} through an error`);
            }
          }
        },
        handleTeamAttack(index, first){
          const c= this;

            if (c.model.battle.team1[index].cards.length > c.model.battle.team1[index].index && c.model.battle.team2[index].cards.length > c.model.battle.team2[index].index) {
              
            let totalMoveCount = 0;
            let moveCount1 = c.getAttachCount(c.model.battle.team1[index].cards[c.model.battle.team1[index].index]);
            let moveCount2 = c.getAttachCount(c.model.battle.team2[index].cards[c.model.battle.team2[index].index]);
            totalMoveCount += moveCount1;
            totalMoveCount += moveCount2;


            if( first < .5){
              for (let i = 0; i < moveCount1; i++) {
                setTimeout(function () {
                  if (
                    c.attemptAttack(
                      c.model.battle.team1[index].cards[c.model.battle.team1[index].index],
                      c.model.battle.team2[index].cards[c.model.battle.team2[index].index],
                      c.model.battle.team1[index].cards,
                      c.model.battle.team2[index].cards,
                      c.model.battle.team1[index].index,
                      c.model.battle.team2[index].index,
                      1
                    )
                  ) {
                    c.model.battle.team2[index].index += 1;
                    c.flip(c.model.battle.team2[index].cards[c.model.battle.team2[index].index]);
                    setTimeout(function () {
                      c.applyTurnAbiltiy(
                        c.model.battle.team2[index].cards[c.model.battle.team2[index].index],
                        c.model.battle.team2[index].cards,
                        c.model.battle.team1[index].cards,
                        c.model.battle.team2[index].index,
                        c.model.battle.team1[index].index,
                        2
                      );
                    }, _FLIP);
                  }
                }, 1000 * i);
              }
              setTimeout(function () {
                for (let i = 0; i < moveCount2; i++) {
                  setTimeout(function () {
                    if (
                      c.attemptAttack(
                        c.model.battle.team2[index].cards[c.model.battle.team2[index].index],
                        c.model.battle.team1[index].cards[c.model.battle.team1[index].index],
                        c.model.battle.team2[index].cards,
                        c.model.battle.team1[index].cards,
                        c.model.battle.team2[index].index,
                        c.model.battle.team1[index].index,
                        2
                      )
                    ) {
                      c.model.battle.team1[index].index += 1;
                      c.flip(c.model.battle.team1[index].cards[c.model.battle.team1[index].index]);
                      setTimeout(function () {
                        c.applyTurnAbiltiy(
                          c.model.battle.team1[index].cards[c.model.battle.team1[index].index],
                          c.model.battle.team1[index].cards,
                          c.model.battle.team2[index].cards,
                          c.model.battle.team1[index].index,
                          c.model.battle.team2[index].index
                        );
                      }, _FLIP);
                    }
                  }, 1000 * i);
                }
              }, 1250 * moveCount1);
            }
            else {
              for (let i = 0; i < moveCount2; i++) {

                setTimeout(function () {
                  if (
                    c.attemptAttack(
                      c.model.battle.team2[index].cards[c.model.battle.team2[index].index],
                      c.model.battle.team1[index].cards[c.model.battle.team1[index].index],
                      c.model.battle.team2[index].cards,
                      c.model.battle.team1[index].cards,
                      c.model.battle.team2[index].index,
                      c.model.battle.team1[index].index,
                      2
                    )
                  ) {
                    c.model.battle.team1[index].index += 1;
                    c.flip(c.model.battle.team1[index].cards[c.model.battle.team1[index].index]);
                    setTimeout(function () {
                      c.applyTurnAbiltiy(
                        c.model.battle.team1[index].cards[c.model.battle.team1[index].index],
                        c.model.battle.team1[index].cards,
                        c.model.battle.team2[index].cards,
                        c.model.battle.team1[index].index,
                        c.model.battle.team2[index].index
                      );
                    }, _FLIP);
                  }
                }, 1000 * i);
              }

              setTimeout(function () {
                for (let i = 0; i < moveCount1; i++) {
                  setTimeout(function () {
                    if (
                      c.attemptAttack(
                        c.model.battle.team1[index].cards[c.model.battle.team1[index].index],
                        c.model.battle.team2[index].cards[c.model.battle.team2[index].index],
                        c.model.battle.team1[index].cards,
                        c.model.battle.team2[index].cards,
                        c.model.battle.team1[index].index,
                        c.model.battle.team2[index].index,
                        1
                      )
                    ) {
                      c.model.battle.team2[index].index += 1;
                      c.flip(c.model.battle.team2[index].cards[c.model.battle.team2[index].index]);
                      setTimeout(function () {
                        c.applyTurnAbiltiy(
                          c.model.battle.team2[index].cards[c.model.battle.team2[index].index],
                          c.model.battle.team2[index].cards,
                          c.model.battle.team1[index].cards,
                          c.model.battle.team2[index].index,
                          c.model.battle.team1[index].index,
                        );
                      }, _FLIP);
                    }
                  }, 1000 * i);
                }
              }, 1250 * moveCount2);
            }

            setTimeout(function () {
              c.handleTeamAttack(
                index,
                first
              );
            }, 2500 * (totalMoveCount - 1));

            return
          
          }
          else{
      
            if (c.model.battle.team1[index].index == c.model.battle.team1[index].cards.length) {
              // console.log('talo player 1')
              // c.model.battle.team2winner.unshift(c.model.battle.team2[index]);
              // for(i = 0; i < c.model.battle.team2[index].cards.length; i++){
              //   const hp = c.model.battle.team2[index].cards[i].hp;
              //     if (hp > 0) {
              //       c.model.battle.cards2.unshift(c.model.battle.team2[index].cards[i])
              //   }
              // }
          
                c.handleWinner(c.model.battle.team2, index, false);
            }
          
            if (c.model.battle.team2[index].index == c.model.battle.team2[index].cards.length) {
                c.handleWinner(c.model.battle.team1, index, true);
            }
          
          }

          if((c.model.battle.tournament.battleOption !== 'single')){
            if(c.model.battle.team1.length == c.model.battle.team1winner.concat(c.model.battle.team2winner).length){
              let $removeContainer= $(`#first_round`);

              $removeContainer.addClass('fade-out');
              setTimeout(function(){
                  $removeContainer.remove()
                  c.model.battle.singleMode = true;
                  c.model.battle.show.profile_intro = true;
                  c.startBattle();
              },2000)
        
            }
          }



        },
        startRound(first) {
          const c = this;
        
          if (c.model.battle.cards1.length > c.model.battle.index1 && c.model.battle.cards2.length > c.model.battle.index2) {
            let totalMoveCount = 0;
            let moveCount1 = c.getAttachCount(c.model.battle.cards1[c.model.battle.index1]);
            let moveCount2 = c.getAttachCount(c.model.battle.cards2[c.model.battle.index2]);
            totalMoveCount += moveCount1;
            totalMoveCount += moveCount2;

            // Randomly choose which card attacks first
            // Card 1 goes first
            if (first < .5) {

              for (let i = 0; i < moveCount1; i++) {
                setTimeout(function() { 
                  if (c.attemptAttack(c.model.battle.cards1[c.model.battle.index1], c.model.battle.cards2[c.model.battle.index2], c.model.battle.cards1, c.model.battle.cards2, c.model.battle.index1, c.model.battle.index2)) {
                    c.model.battle.index2 += 1;
                    c.flip(c.model.battle.cards2[c.model.battle.index2]);
                    setTimeout(function() {
                      c.applyTurnAbiltiy(c.model.battle.cards2[c.model.battle.index2], c.model.battle.cards2, c.model.battle.cards1, c.model.battle.index2, c.model.battle.index1);
                    }, _FLIP);
                  }
                }, 1000 * i);
              }

              setTimeout(function() { 

                for (let i = 0; i < moveCount2; i++) {
                  setTimeout(function() { 
                    if (c.attemptAttack(c.model.battle.cards2[c.model.battle.index2], c.model.battle.cards1[c.model.battle.index1], c.model.battle.cards2, c.model.battle.cards1, c.model.battle.index2, c.model.battle.index1)) {
                      c.model.battle.index1 += 1;
                      c.flip(c.model.battle.cards1[c.model.battle.index1]);
                      setTimeout(function() {
                        c.applyTurnAbiltiy(c.model.battle.cards1[c.model.battle.index1], c.model.battle.cards1, c.model.battle.cards2, c.model.battle.index1, c.model.battle.index2);
                      }, _FLIP);
                    }
                  }, 1000 * i);
                }

              }, 1250 * moveCount1);
              
            // Card 2 goes first
            } else {

              for (let i = 0; i < moveCount2; i++) {
                setTimeout(function() { 
                  if (c.attemptAttack(c.model.battle.cards2[c.model.battle.index2], c.model.battle.cards1[c.model.battle.index1], c.model.battle.cards2, c.model.battle.cards1, c.model.battle.index2, c.model.battle.index1)) {
                    c.model.battle.index1 += 1;
                    c.flip(c.model.battle.cards1[c.model.battle.index1]);
                    setTimeout(function() {
                      c.applyTurnAbiltiy(c.model.battle.cards1[c.model.battle.index1], c.model.battle.cards1, c.model.battle.cards2, c.model.battle.index1, c.model.battle.index2);
                    }, _FLIP);
                  }
                }, 1000 * i);
              }

              setTimeout(function() { 

                for (let i = 0; i < moveCount1; i++) {
                  setTimeout(function() { 
                    if (c.attemptAttack(c.model.battle.cards1[c.model.battle.index1], c.model.battle.cards2[c.model.battle.index2], c.model.battle.cards1, c.model.battle.cards2, c.model.battle.index1, c.model.battle.index2)) {
                      c.model.battle.index2 += 1;
                      c.flip(c.model.battle.cards2[c.model.battle.index2]);
                      setTimeout(function() {
                        c.applyTurnAbiltiy(c.model.battle.cards2[c.model.battle.index2], c.model.battle.cards2, c.model.battle.cards1, c.model.battle.index2, c.model.battle.index1);
                      }, _FLIP);
                    }
                  }, 1000 * i);
                }
              }, 1250 * moveCount2);
        
            }

            setTimeout(function() {  
              c.startRound(c.model.battle.cards1, c.model.battle.cards2, c.model.battle.index1, c.model.battle.index2, first);
            }, 2500 * (totalMoveCount - 1));

            return;
        
          }

          if (c.model.battle.index2 == c.model.battle.cards2.length) {
            c.playerDefeated(2);
            return 1;
          } else {
            c.playerDefeated(1);
            return 2;
          }
            
          
        },
        applyTurnAbiltiy(card, cards1, cards2, index1, index2) {
          const c = this;
          try {
            if (card && card.abilityKey && typeof abilities.turn[`${card.abilityKey}`] === 'function') {
              abilities.turn[`${card.abilityKey}`](cards1, cards2, index1, index2, c.model.battle.events, c.logEvent.bind(c));
              c.logEvent(`${card.name} used ${card.ability}!`, 'ability', { tier: card.tier });
            }
          } catch(err) {
            c.logError(`${card.ability} through an error`);
          }
        },
        attemptAttack(card1, card2, cards1, cards2, index1, index2) {
          const c = this;

          if (!card1 || !card2) {
            return false;
          }
          
          if (card1.turnSkips > 0) {
            card1.turnSkips -= 1;
            c.saveEvent({cardId: card1.id, skipped: true});
            c.logEvent(`${card1.name}'s turn was skipped`, 'skip', { tier: card1.tier });
            return false;
          }

          c.model.battle.audio?.move?.play();

          try {
            if (typeof abilities.move[`${card1.abilityKey}`] === 'function') {
              abilities.move[`${card1.abilityKey}`](cards1, cards2, index1, index2, c.model.battle.events, c.logEvent.bind(c));
              c.logEvent(`${card1.name} used ${card1.ability}!`, 'ability', { card: card1.name, ability: card1.ability, tier: card1.tier });
            }
          } catch(err) {
            c.logError(`${card1.ability} through an error`);
          }

          c.cardAttack(card1);
          let cardHp = card2.hp;

          if (Math.random() * 100 < Number(card1.accuracy)) {
            const randomDamage = Math.floor(Math.random() * 200) + 50;
            const initialDamage = Math.max(randomDamage, Number(card1.attack) - Number(card2.defence));

            let damageVariancePercent = Math.floor(Math.random() * (100 - 75) + 75);
            const critChance = Number(card1.critChance) || Number(card1.criticalChance) || 5;
            let critical = false;

            if (Math.random() * 100 < critChance) {
              critical = true;
              damageVariancePercent = 100 + (Math.floor(Math.random() * (20 - 1) + 1));
            }

            if (window.traits && traits.blocksCriticalHit && traits.blocksCriticalHit(card1)) { critical = false; }

            const variedDamage = Math.round((damageVariancePercent / 100) * initialDamage);
            cardHp -= variedDamage;

            c.logEvent(`${card1.name} attacks ${card2.name}! Damage: ${variedDamage}`, 'attack', {
              attacker: card1.name, defender: card2.name, totalDamage: variedDamage,
              physicalDamage: variedDamage, magicDamage: 0,
              pAtk: Number(card1.attack) || 0, armor: Number(card2.defence) || 0,
              mAtk: 0, ward: 0, critical, tier: card1.tier
            });

            c.saveEvent({cardId: card1.id, damage: variedDamage, critical: critical});
            c.damageTaken(card2, variedDamage, critical, cards1, cards2, index1, index2);

            if (critical && window.abilities && typeof abilities.onCrit?.[`${card1.abilityKey}`] === 'function') {
              try {
                abilities.onCrit[`${card1.abilityKey}`](cards1, cards2, index1, index2, c.model.battle.events, c.logEvent.bind(c));
                c.logEvent(`${card1.name} critical hit triggered ${card1.ability}!`, 'ability', { card: card1.name, ability: card1.ability, tier: card1.tier });
              } catch(err) {
                c.logError(`${card1.ability} onCrit threw an error`);
              }
            }

            if (window.abilities && window.abilities.onHit && typeof abilities.onHit[`${card1.abilityKey}`] === 'function') {
              try {
                abilities.onHit[`${card1.abilityKey}`](cards1, cards2, index1, index2, variedDamage, critical, c.model.battle.events, c.logEvent.bind(c));
              } catch(err) {
                c.logError(`${card1.ability} onHit threw an error`);
              }
            }

            if (window.traits && card1.traitSlug && !card1.traitUsed && card2) {
              const _resolvedSlug = traits.resolveSlug(card1.traitSlug) || card1.traitSlug;
              const canApply = !['burning', 'poisoned', 'bleeding'].includes(_resolvedSlug) || traits.canApplyDot(card1);
              if (canApply) {
                traits.apply(card2, card1.traitSlug);
                card1.traitUsed = true;
                const _traitLabel = (traits.definitions[_resolvedSlug] && traits.definitions[_resolvedSlug].label) || _resolvedSlug;
                c.logEvent(`${card2.name} is afflicted with ${_traitLabel}!`, 'ability', { tier: card1.tier });
              }
            }

            if (cardHp <= 0) {
              if (window.abilities && window.abilities.onDefeated && typeof abilities.onDefeated[`${card2.abilityKey}`] === 'function') {
                try {
                  const excessDamage = Math.max(0, variedDamage - card2.hp);
                  abilities.onDefeated[`${card2.abilityKey}`](cards2, cards1, index2, index1, excessDamage, c.model.battle.events, c.logEvent.bind(c));
                } catch(err) {
                  c.logError(`${card2.ability} onDefeated threw an error`);
                }
              }
              if (window.abilities && window.abilities.onKill && typeof abilities.onKill[`${card1.abilityKey}`] === 'function') {
                try {
                  abilities.onKill[`${card1.abilityKey}`](cards1, cards2, index1, index2, c.model.battle.events, c.logEvent.bind(c));
                } catch(err) {
                  c.logError(`${card1.ability} onKill threw an error`);
                }
              }
              c.cardDefeated(card2);
              return true;
            }
          } else {
            c.saveEvent({cardId: card1.id, missed: true});
            c.logEvent(`${card1.name} missed their attack against ${card2.name}`, 'miss', {
              attacker: card1.name, defender: card2.name, tier: card1.tier
            });

            if (window.abilities && window.abilities.onMissed && typeof abilities.onMissed[`${card2.abilityKey}`] === 'function') {
              try {
                abilities.onMissed[`${card2.abilityKey}`](cards2, cards1, index2, index1, c.model.battle.events, c.logEvent.bind(c));
              } catch(err) {}
            }

            if (window.abilities && window.abilities.onMiss && typeof abilities.onMiss[`${card1.abilityKey}`] === 'function') {
              try {
                abilities.onMiss[`${card1.abilityKey}`](cards1, cards2, index1, index2, c.model.battle.events, c.logEvent.bind(c));
              } catch(err) {}
            }
          }

          return false;
        },
        cardAttack(card) {
          const c = this;
          return new Promise((resolve) => {
            let $card = $(`#${card.id}`).find('.playing-card-wrapper');
            $card.addClass('attack');

            const isPlayer2 = c.model.battle.cards2.some(c2 => c2.id === card.id);
            const vfxSrc = `vfx/${card.cardId}.webm`;

            const $vfx = $(`
              <div class="attack-vfx-fullscreen ${isPlayer2 ? 'flipped' : ''}">
                <video autoplay muted playsinline src="${vfxSrc}" type="video/webm"></video>
              </div>
            `);

            const cardsSide = isPlayer2 ? '.cards-1' : '.cards-2';
            const $cardTarget = $(`[data-component="battle-arena"] ${cardsSide} .playing-card-container:nth-child(1)`);
            $cardTarget.append($vfx);

            setTimeout(function() {
              $vfx.remove();
              $card.removeClass('attack');
              resolve();
            }, 2000);
          });
        },
        damageTaken(card, damage, critical, cards1, cards2, index1, index2) {
          const c = this;
          let $card = $(`#${card.id}`);

          let $hpLost = $(`<span class="hp-lost">-${damage}</span>`);
          $card.append($hpLost);
          $card.find('.playing-card-wrapper').addClass('-shakeX');

          const $hpFill = $card.find('.hp-fill');
          const $resourceBars = $card.find('.resource-bars');
          if ($hpFill.length) {
            $hpFill.addClass('depleting');
            $resourceBars.addClass('shake-effect');
          }

          if (critical) {
            $card.find('.playing-card-wrapper').addClass('-flash');
          }

          const criticalText = critical ? ' (CRITICAL HIT!)' : '';
          c.logEvent(`${card.name} took ${damage} damage${criticalText}`, 'damage', { tier: card.tier });

          setTimeout(function() {
            if (card.hp - damage < 0) {
              card.hp = 0;
            } else {
              card.hp -= damage;

              if (window.traits) { traits.processOnHit(card, damage, critical, c.logEvent.bind(c)); }

              try {
                if (typeof abilities.damaged[`${card.abilityKey}`] === 'function') {
                  abilities.damaged[`${card.abilityKey}`](cards2, cards1, index2, index1, damage, c.model.battle.events, critical, c.logEvent.bind(c));
                  c.logEvent(`${card.name} used ${card.ability}!`, 'ability', { tier: card.tier });
                }
              } catch(err) {
                c.logError(`${card.ability} through an error`);
              }

              if (critical && window.abilities && window.abilities.teamCrit) {
                const supportCard = cards2[index2 + 1];
                if (supportCard && supportCard.hp > 0 && typeof abilities.teamCrit[`${supportCard.abilityKey}`] === 'function') {
                  try {
                    abilities.teamCrit[`${supportCard.abilityKey}`](cards2, cards1, index2 + 1, index1, c.model.battle.events);
                    c.logEvent(`${supportCard.name} reacted to ${card.name} taking a critical hit!`, 'ability', { card: supportCard.name, ability: supportCard.ability, tier: supportCard.tier });
                  } catch(err) {
                    c.logError(`${supportCard.ability} teamCrit threw an error`);
                  }
                }
              }
            }

            const cardPAtk = Number(card.pAtk) || Number(card.attack) || 0;
            const cardMAtk = Number(card.mAtk) || 0;
            const DEFENSE_REGEN = 8;

            if (cardPAtk > 0) {
              c.$set(card, 'currentStamina', Math.min(card.maxStamina || 100, (card.currentStamina || 0) + DEFENSE_REGEN));
            }
            if (cardMAtk > 0) {
              c.$set(card, 'currentMana', Math.min(card.maxMana || 100, (card.currentMana || 0) + DEFENSE_REGEN));
            }

            c.model.battle.audio?.hit?.play();

            $hpLost.addClass('show');
            $card.find('.playing-card-wrapper').removeClass('-shakeX -flash');

            if ($hpFill.length) {
              setTimeout(() => {
                $hpFill.removeClass('depleting');
                $resourceBars.removeClass('shake-effect');
              }, 500);
            }
          }, 300);

          setTimeout(function() {
            $hpLost.addClass('remove');
            setTimeout(function() {
              $hpLost.remove();
            }, 3000);
          }, 1300);
        },
        cardDefeated(card) {
          let c = this;
          //setTimeout(function() {
            let $card = $(`#${card.id}`);
            $card.addClass('remove');

            setTimeout(function() {
              $card.remove();
            }, 1000);
          //}, 1000);

          c.saveEvent({cardId: card.id, defeated: true});
          c.logEvent(`${card.name} was defeated!`, 'defeat', { tier: card.tier });
        },
        handleWinner(team, index, isTeam1) {

          const c = this;

          const winner = isTeam1 ? c.model.battle.team1[index] : c.model.battle.team2[index];
          const loser = isTeam1 ? c.model.battle.team2[index] : c.model.battle.team1[index];
          const $user = $(`[data-id="${loser.user.twitchId}"]`);
          const $playingCardFront = $user.find('.eliminated-icon');
          $playingCardFront.addClass('show');
          const winnerTwitchId = winner.user.twitchId;
          const loserTwitchId = loser.user.twitchId;
          const winnerDisplayName = winner.user.twitchDisplayName;

          if (isTeam1) {
              if (!c.model.battle.team1winner.includes(winner)) {
                  c.model.battle.team1winner.unshift(winner);
                    // Add cards to the respective model
                  for (let i = 0; i < winner.cards.length; i++) {
                    const hp = winner.cards[i].hp;
                    if (hp > 0) {
                      if (!c.model.battle.cards1.includes(winner.cards)) {
                        c.model.battle.cards1.unshift(winner.cards[i]);
                      }
                    }
                  }
              }
            
          } else {
              if (!c.model.battle.team2winner.includes(winner)) {
                  c.model.battle.team2winner.unshift(winner);
                    // Add cards to the respective model
                  for (let i = 0; i < winner.cards.length; i++) {
                    const hp = winner.cards[i].hp;
                    if (hp > 0) {
                      if (!c.model.battle.cards2.includes(winner.cards)) {
                        c.model.battle.cards2.unshift(winner.cards[i]);
                      }
                    }
                  }
              }
            
          }

          let data = {
              id: winner.id,
              winnerTwitchId: winnerTwitchId,
              loserTwitchId: loserTwitchId,
              events: c.model.battle.events,
              factionId: winner.factionId,
              loserfactionId: loser.factionId,
          };

          if (c.model.battle.isTournamentOpen) {
              data.round = winner.round;
              data.index = winner.bracketIndex;
              data.tournamentId = winner.tournamentId;
              data.bracket = winner.bracket;
              data.twitchDisplayName = winnerDisplayName;
              data.tournamentTeamUsed = winner.tournamentTeamUsed;
              data.playerStat = isTeam1 ? 'player1' : 'player2';
              data.autobattle = c.model.battle.tournament.auto;
          }
          if (c.model.battle.tournament.battleOption === 'single') {
              c.saveBattle(data);
          }
        },
        playerDefeated(player) {
          const c = this;
          
          c.logEvent(`Player ${player} was defeated!`);

          c.model.battle.battleLoaded = false;
          c.model.battle.show.cards = false;
          c.model.battle.show.users = false;
          c.model.prepareBattle = false;
          let status;
          if(player === 1){
            status = 'lose';
            c.model.battle.result = 'lose';
          }
          else{
            status = 'win';
            c.model.battle.result = 'win';
          }

          c.model.battle.show.winner = true;

          c.model.battle.audio.win.play();
          
          let data = {
            status : player === 1 ? 0 : 1,
            id: c.model.selectedEvent.userEvent[0].id,
            active: 0,
            isBattle: true
          }

          c.model.battle.saving = true;
          
          // if(c.model.battle.tournament){
          //   const playerStat = player == 1 ? 'player2' : 'player1';
          //   data.round = c.model.battle.tournamentData.round
          //   data.index = c.model.battle.tournamentData.index
          //   data.tournamentId = c.model.battle.tournament.id
          //   data.bracket = c.model.battle.tournamentData.bracket
          //   data.twitchDisplayName = winnerDisplayName
          //   data.tournamentTeamUsed  = c.model.battle.tournamentData.tournamentTeamUsed
          //   data.playerStat  = playerStat
          //   data.tournamentId = c.model.battle.tournament.id;
          //   data.autobattle = c.model.battle.tournament.auto
          //   data.channelId = utils.cookies.get('user_id');
          // }

          setTimeout(function() {
              if (c.model.battle.settings.autobattle && c.model.battle.settings.stealcards.value) {
              c.model.battle.stolenCard = c.stealCard(player == 1 ? c.model.battle.cards1 : c.model.battle.cards2);
              data.stolenCardId = c.model.battle.stolenCard.id;

              setTimeout(function() {
                c.model.battle.show.stolenCard = true;
                c.flip(c.model.battle.stolenCard);

                setTimeout(function() {
                  c.model.battle.show.stolenCard = false;
                  setTimeout(function() {
                    c.saveBattle(data, false);
                  }, 500);
                }, 3500);
              }, 1500);
            } else {
              c.saveBattle(data, false);
            }
          }, 3500);
          
        },
        saveBattle(data, isTeam) {
          const c = this;
          

          if(isTeam){
            teamBattleService.save(data)
            .then(function (response) {
              c.ws.send(JSON.stringify(data));
              c.model.battle.saving = false;
              setTimeout(function(){
                window.location.reload();
              },5000)
            })
            .catch(function (error) {
              c.model.battle.saving = false;
              console.log(error);
            })
          }
          else{

            eventsService.saveUserEvent(data)
            .then(function (response) {
                c.model.battle.saving = false;
                console.log(response)
            })
            .catch(function (error) {
              c.model.battle.saving = false;
              c.logEvent(error);
            });
          }
        },
        showStats() {
          $('.info').removeClass('is-visible');
          $('.bottom').removeClass('is-hidden');
        },
        saveEvent(data) {
          const c = this;
          data.battleId = c.model.battle.id;
          c.model.battle.events.push(data);
        },
        logEvent(message, type = 'info', meta = {}) {
          const c = this;
          console.log(message);
          c.model.battle.show.logs = true;
          setTimeout(function() {
            const logEntry = {
              message: message,
              type: type,
              timestamp: Date.now(),
              tier: meta.tier || null,
            };
            if (meta && Object.keys(meta).length > 0) {
              Object.assign(logEntry, { meta: meta });
            }
            c.model.battle.logs.unshift(logEntry);
            c.model.battle.logs = c.model.battle.logs.slice(0, 20);
          }, 300);
        },
        logError(message) {
          const c = this;
          // console.log(message)
          // logService.save({message: message})
          //   .then(function (response) { })
          //   .catch(function (error) { });
        },
        stealCard(cards) {
          const index = Math.floor(Math.random() * cards.length);
          return cards[index];
        },
        getAttachCount(card) {
          const c = this;
          const maxSpeed = 6000;
          const cardSpeed = card.speed;

          if (cardSpeed == maxSpeed) {
            maxSpeed = maxSpeed * 1.2;
          }

          let chance = (cardSpeed / maxSpeed) / 3; 
          chance = Math.round(chance * 100) / 100;

          if (Math.random() < chance) {
            return 2;
          }

          return 1;

        },
        flip(card, timeout = _FLIP) {
          const c = this;
          if (!card) return;
          setTimeout(function() {
            let id = card.id;
            c.$root.$emit(`flip${id}`, id);
            c.model.battle.audio.flip.play();
            c.showStats();
          }, timeout);
        },
        isResponseEmpty(response) {
          const c = this;
        
          if (typeof response !== 'object' || response === null) {
              return true;
          }

        
          const keys = Object.keys(response);

        
          if (keys.length === 0) {
              return true;
          }

        
          for (const key of keys) {
              if (Array.isArray(response[key]) && response[key].length === 0) {
                  return true; 
              }
          }
        
          return false;
        },
        reset(){
          const c = this;
          c.model.events = [];
          c.model.eventName = '';
          c.model.selectedEvent = {};
          c.model.battle = {
            selectedTeam: {},
            team: null,
            teams: [],
            abilities: [],
            settings: {},
            audio: {},
            logs: [],
            events: [],
            cardNumber: [],
            cards1: [],
            cards2: [],
            index1: 0,
            index2: 0,
            userLevel: 0,
            saving: false,
            user1: {
                twitchId: null,
                twitchDisplayName: null,
                twitchProfileImage: null,
            },
            user2: {
                twitchId: null,
                twitchDisplayName: null,
                twitchProfileImage: null,
            },
            show: {
                winner: false,
                cards: false,
                stolenCard: false,
                users: false,
                move: false,
                logs: false,
                modal: true
            }
          }
          c.model.eventOpen = true;
          c.model.hasEvent = true;
          c.model.battle.result = null;
          c.model.battle.team = null;
          c.model.battle.teams = [];
        },
        saveProcessedRewards(twitchId) {
          const c = this;
          const r = c.model.rewards;
          const payload = {
            twitchId: twitchId,
            userCards: r.userCards || [],
            eventCards: r.eventCards || [],
            exoticCards: r.exoticCards || [],
            variantCards: r.variantCards || [],
            deltaCards: r.deltaCards || [],
            userPacks: r.userPacks || [],
            rewardCardBacks: r.rewardCardBacks || [],
            rewardFrames: r.rewardFrames || [],
            rewardBackgrounds: r.rewardBackgrounds || []
          };
          eventsService.saveProcessedRewards(payload)
            .catch(function(error) {
              console.error('saveProcessedRewards failed', error);
            });
        },
        getRewards(data){
          const c = this;

          let count = 0;
          // Handle barks
          if (data.rewards.barks) {
            let barks = {
                name: 'barks',
                value: data.rewards.barks
            };
            c.model.rewards.otherRewards.push(barks);
            count++;
            // c.model.rewardCount += 1
          }

          // Handle xp
          if (data.rewards.xp) {
            let xp = {
                name: 'xp',
                value: data.rewards.xp
            };
            c.model.rewards.otherRewards.push(xp);
            count++;
            // c.model.rewardCount += 1
          }
          // Handle packs
          if (data.rewards.givePack && Array.isArray(data.rewards.givePack)) {
              for (let pack of data.rewards.givePack) {
                  if (pack) {
                      const fullPack = c.model.packs[pack.packId];
                      if (fullPack) {
                          pack.images = fullPack.images;
                          pack.isChest = fullPack.isChest;
                      }
                      if (pack.images && Object.keys(pack.images).length > 0) {
                          const firstKey = Object.keys(pack.images)[0];
                          const imageName = pack.images[firstKey];
                          const folder = pack.isChest ? 'chest' : 'packs';
                          pack.image_url = `${root}/images/${folder}/${imageName}.png`;
                      } else {
                          pack.image_url = `${root}/images/packs/${pack.packId}.png`;
                      }
                      c.model.rewards.userPacks.push(pack);
                      count++;
                  }
              }
          }

          // Handle cards
          if (data.rewards.randomCard && Array.isArray(data.rewards.randomCard)) {
              for (let cardData of data.rewards.randomCard) {
                  if (cardData && typeof cardData.random_amount === 'number' && cardData.random_amount > 0) {
                      for (let j = 0; j < cardData.random_amount; j++) {
                          const allCardsByTier = playingCards.groupCardsByTier(c.model.cards);
                          let cards;
      
                          switch (cardData.randomCard) {
                              case 1:
                                  cards = playingCards.getCard(allCardsByTier, null, 'normal');
                                  break;
                              case 2:
                                  cards = playingCards.getCard(allCardsByTier, null, 'ultra');
                                  break;
                              case 3:
                                  cards = playingCards.getCard(allCardsByTier, null, 'legendary');
                                  break;
                              case 4:
                                  cards = playingCards.getCard(allCardsByTier, null, 'ultimate');
                                  break;
                              case 5:
                                  cards = playingCards.getBoneCard(c.model.boneCards);
                                  cards.tier = 5
                                  break;
                              default:
                                  cards = playingCards.getAscension(c.model.ascensionCard);
                                  break;
                          }
      
                          if (cards) {
                              cards.image = `${root}/images/cards/${cards.id}.png`;
                              cards.twitchId = utils.cookies.get('user_id');
                              cards.unlockQueueId = data.unlockQueueId, 
                              cards.cardId = cards.id;
                              c.model.rewards.userCards.push(playingCards.getCardStats(cards, c.model.abilities));
                              // c.saveRandomCard(cards);
                          } else {
                              console.warn('No card found for card type:', cardData.card);
                          }
                          count++;
                      }
                  } else {
                      console.warn('Invalid card data or amount:', cardData);
                  }
              }
            
              // c.model.rewardCount += data.rewards.random_amount
      
          } else {
              console.warn('cards is not an array or is undefined:', data.cards);
          }

          if (data.rewards.selectedCard && Array.isArray(data.rewards.selectedCard)) {
            for (let cardData of data.rewards.selectedCard) {
              cardData.image = `${root}/images/cards/${cardData.id}.png`;
              cardData.tier = cardData.card_tier;
              c.model.rewards.userCards.push(playingCards.getCardStats(cardData, c.model.abilities));
              count++;
            }

            // c.model.rewardCount += data.rewards.cards_amount 
          }
          else {
              console.warn('cards is not an array or is undefined:', data.cards);
          }

          if (data.rewards.eventCard && Array.isArray(data.rewards.eventCard)) {
            for (let cardData of data.rewards.eventCard) {
              if (cardData.is_modified_existing) {
                cardData.image = `${root}/images/temp_cards/${cardData.id}.png`;
              } else {
                cardData.image = `${root}/images/cards/${cardData.id}.png`;
              }
              cardData.tier = cardData.card_tier;
              c.model.rewards.eventCards.push(playingCards.getCardStats(cardData, c.model.abilities));
              count++;
            }
          }

          if (data.rewards.exoticCard && Array.isArray(data.rewards.exoticCard)) {
            for (let cardData of data.rewards.exoticCard) {
              cardData.image = `${root}/images/cards/${cardData.id}.png`;
              c.model.rewards.exoticCards.push(playingCards.getCardStats(cardData, c.model.abilities));
              count++;
            }
          }

          if (data.rewards.variantCard && Array.isArray(data.rewards.variantCard)) {
            for (let cardData of data.rewards.variantCard) {
              const id = cardData.cardId || cardData.id;
              if (id) {
                cardData.image = `${root}/images/cards/${id}.png`;
                cardData.tier = 9;
                c.model.rewards.variantCards.push(playingCards.getCardStats(cardData, c.model.abilities));
                count++;
              }
            }
          }

          if (data.rewards.deltaCard && Array.isArray(data.rewards.deltaCard)) {
            for (let cardData of data.rewards.deltaCard) {
              if (cardData.deltaCardId) {
                const amount = cardData.card_amount || 1;
                for (let d = 0; d < amount; d++) {
                  c.model.rewards.deltaCards.push({
                    id: cardData.deltaCardId,
                    name: cardData.name || 'Delta Card',
                    image: `${root}/images/delta-cards/${cardData.deltaCardId}.png`,
                    tier: 10,
                    effect: cardData.effect,
                    description: cardData.description
                  });
                  count++;
                }
              }
            }
          }

          if (data.rewards.chest && Array.isArray(data.rewards.chest)) {
            for (let chest of data.rewards.chest) {
              const fullPack = c.model.packs[chest.packId || chest.id];
              if (fullPack && fullPack.images && Object.keys(fullPack.images).length > 0) {
                const firstKey = Object.keys(fullPack.images)[0];
                const imageName = fullPack.images[firstKey];
                chest.image_url = `${root}/images/chest/${imageName}.png`;
              } else {
                const id = chest.packId || chest.id;
                chest.image_url = `${root}/images/chest/${id}/1.png`;
              }
              c.model.rewards.rewardChests.push(chest);
              count++;
            }
          }

          if (data.rewards.rewardCardBacks && Array.isArray(data.rewards.rewardCardBacks)) {
            for (let back of data.rewards.rewardCardBacks) {
              back.image_url = `${root}/images/card-backs/${back.id}.png`;
              c.model.rewards.rewardCardBacks.push(back);
              count++;
            }
          }

          if (data.rewards.rewardBackgrounds && Array.isArray(data.rewards.rewardBackgrounds)) {
            for (let bg of data.rewards.rewardBackgrounds) {
              const id = bg.backgroundId || bg.background_id || bg.id;
              const ext = bg.extension || bg.background_extension || 'png';
              bg.image_url = `${root}/images/backgrounds/${id}/${id}.${ext}`;
              c.model.rewards.rewardBackgrounds.push(bg);
              count++;
            }
          }

          if (data.rewards.rewardFrames && Array.isArray(data.rewards.rewardFrames)) {
            for (let frame of data.rewards.rewardFrames) {
              const id = frame.frameId || frame.frame_id || frame.id;
              const ext = frame.extension || frame.frame_extension || 'png';
              frame.image_url = `${root}/images/frames/${id}/${id}.${ext}`;
              c.model.rewards.rewardFrames.push(frame);
              count++;
            }
          }

          const modal = document.querySelector('.reward-modal');
          if (modal) {
              modal.classList.add('active');
              c.model.audio.reward.play();
              
              c.model.rewards.rewardCount = count;
              setTimeout(() => {
                  const hiddenBottoms = document.querySelectorAll(
                      '.reward-modal.active .chest-card-reward .bottom.is-hidden, ' +
                      '.reward-modal.active .reward-card-component.playing-card-container .bottom.is-hidden'
                  );
                  hiddenBottoms.forEach(bottom => {
                      bottom.classList.remove('is-hidden');
                  });
              }, 200);
          } else {
              console.warn('Chest modal not found');
          }
        }
  },
});